module.exports = __webpack_public_path__ + "de77a722/img/settings-icon.121d9519.svg";